// extracted by mini-css-extract-plugin
module.exports = {"active":"OfferCardActiveWrapper_active___c39T"};